import React, { useMemo, useReducer, useState } from 'react'
import { Route, Redirect, Switch, useLocation } from 'react-router-dom'

import * as path from './routes'

import { adminReducer } from './helper'
import { ConfigContext, initConfig } from './context/configContext'
import AuthScreen from './Screens/Partner/AuthScreen/AuthScreen'
import 'antd/dist/antd.css'
import '@yaireo/tagify/dist/tagify.css'
import './App.css'
import { ConfigProvider } from 'antd'
import ruRu from 'antd/es/locale/ru_RU'
import './plugins/input-scroll-disable'
import useCoordinatorState from './hooks/useCoordinatorState'
import ImageTestScreen from './Screens/ImageTestScreen'
import { CitizenshipContext } from './context/partnerCitizenship'
import NotFoundScreen from './Screens/NotFoundScreen'
import { AppConfig } from './AppConfig'

const auth = {
  hasRole: role => role === 'Admin' || role === 'PartnerProfile'
}

const App = () => {
  const location = useLocation()
  const portalButtonState = useCoordinatorState()
  const [config, setConfig] = useReducer(adminReducer, initConfig)
  const [citizenship, setCitizenship] = useState(null)

  const isImgTest = useMemo(() => {
    return location.search === '?imgtest'
  }, [location.search])

  const isNotFoundLink = useMemo(() => {
    return [
      `?${AppConfig.urlRoleCodes.selfEmployedResearcher}`,
      `?${AppConfig.urlRoleCodes.selfEmployed}`,
      `?${AppConfig.urlRoleCodes.selfEmployedOperator}`,
      `?${AppConfig.urlRoleCodes.selfEmployedMentor}`
    ].includes(location.search)
  }, [location.search])

  return (
    <div className='App'>
      <ConfigProvider locale={ruRu}>
        <ConfigContext.Provider value={{ ...config, setConfig, portalButtonState }}>
          <CitizenshipContext.Provider value={{ citizenship, setCitizenship }}>
            <Switch>
              {isNotFoundLink && (
                <Route path='/' exact render={() => <NotFoundScreen />} />
              )}
              {isImgTest ? (
                <Route path='/' exact render={() => <ImageTestScreen />} />
              ) : (
                <Route path='/' exact render={() => <AuthScreen auth={auth} />} />
              )}
              {Object.keys(path.routes).map(key =>
                path.routes[key].map(item => (
                  <PrivateRoute key={item.path} auth={auth} authRole={key} {...item} />
                ))
              )}
              <Redirect from='*' to='/' />
            </Switch>
          </CitizenshipContext.Provider>
        </ConfigContext.Provider>
      </ConfigProvider>
    </div>
  )
}

export default App

export const PrivateRoute = ({ component, auth, authRole, city, ...rest }) => {
  const renderFn = Component => props =>
    auth.hasRole(authRole) || rest.publicRoute ? (
      <Component auth={auth} {...props} city={city} />
    ) : (
      <Redirect to='/' />
    )

  return <Route {...rest} render={renderFn(component)} />
}
